import React, { CSSProperties, useEffect, useState } from "react";
import { getDownloadUrl } from "../firebase";



interface Props {
  src: string;
  className?: string;
  style?: CSSProperties;
  onLoad?: (src: string) => void;
}

const FirebaseImage: React.FC<Props> = ({ src, className, style, onLoad }) => {
  const [ url, setUrl ] = useState<string>();

  const processImage = async () => {
    const link = await getDownloadUrl(src);
    if (link) {
      setUrl(link);
    }
  }

  useEffect(() => {
    processImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ src ]);

  const imgOnLoad = () => {
    onLoad && onLoad(src);
  }

  if (!url) {
    return null;
  }
  
  return (
    <img style={style} className={className} src={url} alt="img layer" onLoad={imgOnLoad} />
  );
};

export default FirebaseImage;